import { render, staticRenderFns } from "./setshipplan.vue?vue&type=template&id=115a4428"
import script from "./setshipplan.vue?vue&type=script&lang=js"
export * from "./setshipplan.vue?vue&type=script&lang=js"
import style0 from "./setshipplan.vue?vue&type=style&index=0&id=115a4428&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports